exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/collections-common.js-WebpackMultiOutput";